import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import "./GenericModal.scss";

function buildPaperStyle({
  width,
  height,
  minWidth,
  maxWidth,
  minHeight,
  maxHeight,
}) {
  const style = {};
  if (width !== undefined) style.width = width;
  if (height !== undefined) style.height = height;
  if (minWidth !== undefined) style.minWidth = minWidth;
  if (maxWidth !== undefined) style.maxWidth = maxWidth;
  if (minHeight !== undefined) style.minHeight = minHeight;
  if (maxHeight !== undefined) style.maxHeight = maxHeight;
  return style;
}

const GenericModal = ({
  open,
  onClose,
  title,
  children,
  footer,
  showTopBar = true,
  width = 413,
  height = "auto",
  minWidth,
  maxWidth,
  minHeight,
  maxHeight,
  className = "",
  disableBackdropClose = false,
  disableEscapeKeyClose = false,
}) => {
  const handleClose = (event, reason) => {
    if (reason === "backdropClick" && disableBackdropClose) return;
    if (reason === "escapeKeyDown" && disableEscapeKeyClose) return;
    onClose?.(event, reason);
  };

  const paperStyle = buildPaperStyle({
    width,
    height,
    minWidth,
    maxWidth,
    minHeight,
    maxHeight,
  });

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className={`generic-modal ${className}`}
      aria-labelledby="generic-modal"
    >
      <div className="generic-modal-paper" style={paperStyle}>
        <div className="generic-modal-topbar">
          {title && <div className="generic-modal-title">{title}</div>}
        </div>

        <div className="generic-modal-body">{children}</div>

        {footer && (
          <DialogActions className="generic-modal-footer">
            {footer}
          </DialogActions>
        )}
      </div>
    </Dialog>
  );
};

export default GenericModal;
